<template>
  <transition-group class="server-message-list" name="server-message" tag="div">
    <div
      class="server-message"
      v-for="{ component, message } in messageList"
      v-bind:key="message.id"
    >
      <component v-bind:is="component" v-bind:message="message.data" v-on:hide="onHide(message)" />
      <button class="server-message__cross" type="button" v-on:click="onHide(message)" />
    </div>
  </transition-group>
</template>

<script>
/**
 * @typedef {import('@/mixins/notifierMixin').ServerMessage} ServerMessage
 */
import ServerMessagePatientCame, { EVENT_PATIENT_CAME } from '@/components/ServerMessagePatientCame.vue';
import ServerMessageInvoiceCreating, { EVENT_INVOICE_CREATING } from '@/components/ServerMessageInvoiceCreating.vue';

export default {
  components: { ServerMessagePatientCame },
  computed: {
    /**
     * @description Список сообщений.
     * @returns {{component:Object,message:ServerMessage}[]}
     */
    messageList() {
      const messages = [];
      this.messages.forEach((message) => {
        switch (message.event) {
          case EVENT_PATIENT_CAME:
            messages.push({ component: ServerMessagePatientCame, message });
            break;
          case EVENT_INVOICE_CREATING:
            messages.push({ component: ServerMessageInvoiceCreating, message });
            break;
          default: break;
        }
      });
      return messages;
    },
  },
  methods: {
    /**
     * @description Обработать скрытие сообщения.
     * @param {ServerMessage} message
     * @returns {void}
     */
    onHide(message) {
      this.$emit('hide-message', message);
    },
  },
  props: {
    messages: { default: () => [], type: Array },
  },
  name: 'ServerMessageNotifier',
};

</script>

<style lang="scss">
.server-message-list {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 3;
  margin: 0 10px 10px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
}
.server-message {
  max-width: 400px;
  width: 100%;
  padding: 10px;
  background-color: var(--action-color);
  border-color: var(--action-color);
  color: white;
  display: flex;
  flex-direction: row;
  gap: 7px;
  &__link {
    color: white !important;
  }
  &__cross {
    width: 15px;
    height: 15px;
    mask-image: url("@/assets/img/exit-black.svg");
    mask-size: 15px 15px;
    mask-repeat: no-repeat;
    mask-position: center;
    background-color: #ffffff;
    flex-shrink: 0;
  }
  &-enter-active,
  &-leave-active {
    transition: all 0.5s ease;
  }
  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translateX(100px);
  }
}
</style>
